import axios from "axios";
import {Configuration} from "../../generated/callApi";
import {OktellApi} from "../../generated/callApi";

export class OktellRepository {
    private service: OktellApi;

    constructor() {
        this.service = new OktellApi(new Configuration(), process.env.REACT_APP_BACKEND_URL)
    }

    async ReadStatuses(): Promise<string[] | Error> {
        try {
            let response = await this.service.apiOktellCallStatusesGet({ headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return response.data;
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }
    
}